<template>
    <div>
        <van-sticky>
            <van-row type="flex" class="border-bottom">
                <van-col span="16">
                    <van-dropdown-menu>
                        <drop-menu title="地区" url="Area/listAll" :data="{pid:'1',code:rssAreaList ? [rssAreaList,'in'] : ''}" @change="okArea" value-key="code" :row-count="4"sub-title="选择地区" ></drop-menu>
                        <drop-menu title="行业" url="Type/listAll" :data="{akey:'industry',id:rssHyList ? [rssHyList,'in'] : ''}" @change="okIndustry" sub-title="选择行业"></drop-menu>
                    </van-dropdown-menu>
                </van-col>
                <van-col span="8" class="bg-light">
                    <div class="flex flex-ai flex-jc brand" style="height: 100%;" @click="toRss">
                        <van-icon name="setting-o" class="margin-right-5"/>设置
                    </div>
                </van-col>
            </van-row>
            <div class="me-banner"></div>
        </van-sticky>
        <flat-list url="Bids/listPage" list-class="margin-top" :data="{'type_industry_id':type_industry_id.length > 0 ? type_industry_id : '','province_code':province_code.length > 0 ? province_code : '',state:1,orderBy:'create_time',sortBy:'desc'}">
            <bids-item slot-scope="scope" :info="scope.row"></bids-item>
<!--            <bids-item slot-scope="scope" :info="scope.row" @click.native="$router.push({path:'/bids/detail/'+scope.row.id})"></bids-item>-->
        </flat-list>
    </div>
</template>

<script>
export default {
    name: "index",
    data(){
        return{
            type_industry_id:[],
            province_code:[],
            rssHyList:[],
            rssAreaList:[],
            rss2:''
        }
    },
    created() {
        this.$emit('bgColor','#f4f4f4');
        this.rss2 = this.$route.query.rss2 ? this.$route.query.rss2 : '';

        // this.rssHyList = this.$user.getHy();
        // this.rssAreaList = this.$user.getArea();
    },
    mounted() {
        if(this.$user.getToken()) {
            this.getMyInterest();
        }
    },
    methods:{
        toRss(){
            if(this.rss2){
                this.$router.push({path: '/rss2'})
            }else {
                this.$router.push({path: '/rss'})
            }
        },
        okIndustry(list){
            this.type_industry_id = JSON.parse(JSON.stringify(list));
        },
        okArea(list){
            this.province_code = JSON.parse(JSON.stringify(list));
        },
        getMyInterest(){
            let _this = this;
            this.$http.post({
                url:'AuthUser/getInterest',
                data:null,
                success(res){
                    _this.rssHyList = res.hangye_ids;
                    _this.rssAreaList = res.province_codes;
                    // _this.hyList = res;
                    // _this.getNotice();
                }
            })
        }
    }
}
</script>
